import React from 'react';
import logos from '../Assests/enfuse-logo.png';

function LinkExpired() {
  return (
    <div className='quiz-container'  style={{margin: '200px auto'}}>
        <center>
        <img src={logos} alt="Company Logo" style={{padding:'20px' , width:'15%'}}/>
        <br/>
        <h1 style={{color:'#020542dc'}}>Welcome Candidate! <br />
        {/* <span style={{color:'#00B4D2', fontSize:'25px'}}>EnFuse Solutions</span> */}
        <br /> Sorry. Your link was expired. <br/>  <br /> Please wait until the team reaches out to you.</h1>
        <br />
        <h1 style={{color:'red'}}>Please Close the Window</h1>
        </center>
    </div>
  )
}

export default LinkExpired;